import Swal from "sweetalert2";
import { googleLogout } from "@react-oauth/google";

export const signOut = async () => {
  // Popup
  await Swal.fire({
    icon: "warning",
    showConfirmButton: false,
    text: "Session expired, please sign in again.",
    timer: 3000,
    allowOutsideClick: false, // Prevents closing when clicking outside
    allowEscapeKey: false, // Prevents closing with the escape key
  });

  googleLogout();
  // Clear session
  sessionStorage.clear();

  setTimeout(function () {
    // Go to sign in page
    window.location.reload();
  }, 2000);
};
